module.exports = __webpack_public_path__ + "img/logo.8d61f769.jpg";